import { stats } from "@/mocks/testimonials";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=moody%20cinematic%20night%20city%20rooftop%20silhouette%20with%20distant%20warm%20amber%20lights%2C%20heavy%20atmosphere%2C%20fog%20and%20film%20grain%2C%20deep%20crimson%20and%20gold%20tints%2C%20mysterious%20investigative%20editorial%20photography%2C%20dark%20tones%20for%20text%20overlay%2C%20no%20text&width=1600&height=900&seq=guatian-hero-night&orientation=landscape"
          alt="夜色中的城市轮廓，营造匿名爆料的沉静氛围"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/60 to-foreground-950/85" />

      <div className="relative mx-auto flex w-full max-w-6xl flex-col items-center px-4 pb-16 pt-32 text-center md:pb-24 md:pt-44">
        <p className="mb-5 inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs font-label tracking-[0.2em] text-background-100 backdrop-blur">
          <i className="ri-lock-2-line text-accent-400" aria-hidden="true" />
          全匿名投稿 · 隐私优先
        </p>
        <h1 className="font-heading text-3xl font-black leading-tight tracking-tight text-background-50 md:text-6xl">
          瓜田爆料
          <span className="mt-3 block text-base font-normal tracking-[0.3em] text-accent-400 md:text-xl">
            知情者说 · 匿名而至
          </span>
        </h1>
        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-100 md:text-lg">
          这里提供匿名投稿、私信投稿与线索征集三条通道。如果你掌握内幕消息，或者身边正好有瓜，
          不必注册、不必署名，写下你知道的那部分就好——剩下的交给我们核实。
        </p>

        <div className="mt-9 flex w-full flex-col items-center justify-center gap-3 sm:w-auto sm:flex-row">
          <a
            href="#submit"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-send-plane-fill" aria-hidden="true" />
            进入在线投稿入口
          </a>
          <a
            href="#channels"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 bg-background-50/5 px-7 py-3.5 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/15 sm:w-auto"
          >
            查看投稿通道
          </a>
        </div>

        <dl className="mt-14 grid w-full max-w-4xl grid-cols-2 gap-x-4 gap-y-8 border-t border-background-50/15 pt-8 md:grid-cols-4">
          {stats.map((item) => (
            <div key={item.label} className="text-center">
              <dt className="sr-only">{item.label}</dt>
              <dd>
                <span className="block font-heading text-2xl font-bold text-accent-400 md:text-3xl">
                  {item.value}
                </span>
                <span className="mt-1 block text-xs text-background-200 md:text-sm">{item.label}</span>
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}